import { Button } from '@mui/material'
import React from 'react'
import { queryClient } from '../../../../../../App'

const StartServiceBtn = ({ currentServiceData, action }) => {
  const handleAction = () => {
    action(currentServiceData.id).then(() => {
      queryClient.invalidateQueries({ queryKey: ['service-table'] })
    })
  }
  return (
    <Button onClick={handleAction} fullWidth variant='contained'>
      Начать обслуживание
    </Button>
  )
}

export default StartServiceBtn
